export function accordion() {

    const container = $('.accordion'),
        button = $('.accordion__item'),
        content = '.accordion__content';
    button.on('click', function () {
        if ($(this).next().hasClass('active')) {
            $(this).removeClass('active');
            $(this).next().stop().slideUp().removeClass('active');
        } else {
            if ($(container).hasClass('hideAll')) {
                $(".accordion__item.active").removeClass("active");
                $(".accordion__content.active").slideUp().removeClass("active");
            }
            $(this).addClass('active');
            $(this).next().stop().slideDown().addClass('active');
        }
    });

}
